/**
 * EU/EEA + UK region codes used for consent defaults.
 * Shared between CookieYes plugin (consent defaults) and GTM plugin (loading strategy).
 */
export const EU_REGIONS =
  'AT,BE,BG,HR,CY,CZ,DK,EE,FI,FR,DE,GR,EL,HU,IE,IT,LV,LT,LU,MT,NL,PL,PT,RO,SK,SI,ES,SE,GB,UK,NO,IS,LI,GG,SM,VA,AD'

export const EU_REGION_SET = new Set(EU_REGIONS.split(','))
